import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Planing, SessionRessource, SessionTrainee, SessionTraineeHistory } from 'app/shared/models/class/planing/planing';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PlaningService {
  planingListChanged = new Subject<any[]>();
  private baseUrl: string = environment.apiUrl + '/Planning';
  private planings: any[] = [];

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getSessionsTraineeHistory(clubCode: string): Observable<SessionTraineeHistory[]> {
    return this.http.get<SessionTraineeHistory[]>(`${this.baseUrl}/SessionTraineeHistory/${clubCode}`);
  }


  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  assignRessource(updateRessource: SessionRessource) {
    return this.http.put(`${environment.apiUrl}/Planning/AssignRessource`, updateRessource);
  }

  assignTrainee(updateTrainee: SessionTrainee) {
    return this.http.put(`${environment.apiUrl}/Planning/AssignTrainee`, updateTrainee);
  }

  notifyClient(bodyToNotify) {

    return this.http.put(`${this.baseUrl}/IsNotified`, bodyToNotify);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     POST                                    */
  /* -------------------------------------------------------------------------- */

  getPlaning(clubCode, startDate, endDate): Observable<Planing[]> {
    this.planings = [];
    const params = {
      clubCode: clubCode,
      startDate: startDate,
      endDate: endDate
    };

    return this.http.post<Planing[]>(`${this.baseUrl}/Planning`, params)
    .pipe(
      tap((planingsFromSrv) => {
        let planingsFiltered = planingsFromSrv.filter(s => s.sessions);

        planingsFiltered.map(planing => {
          planing.sessions.map(session => {
            let planingFormated = {
              clubRessourceFirstName: planing.clubRessourceFirstName,
              clubRessourceKey: planing.clubRessourceKey,
              clubRessourceLastName: planing.clubRessourceLastName,
              clubRessourcePseudo: planing.clubRessourcePseudo,
              dateLib: session.dateLib,
              offerName: session.offerName,
              sessionEndDate: moment(session.sessionEndDate).utc().format('DD/MM/YYYY HH:mm'),
              sessionKey: session.sessionKey,
              sessionStartDate: moment(session.sessionStartDate).utc().format('DD/MM/YYYY HH:mm'),
            }



            this.planings.push(planingFormated);
          })
        })

        this.planingListChanged.next([...this.planings]);
      })
    );
  }

}
